const DEFAULT_API_URL = "https://wss.intern.jape-dev.de";
const DEFAULT_WS_URL = "wss://wss.intern.jape-dev.de";
const DEFAULT_FRONTEND_URL = "https://liste.schule.projects.jape-dev.de";

function trimTrailingSlash(url) {
  return url.replace(/\/+$/, "");
}

export const API_URL = trimTrailingSlash(process.env.REACT_APP_API_URL || DEFAULT_API_URL);
export const WS_URL = trimTrailingSlash(process.env.REACT_APP_WS_URL || DEFAULT_WS_URL);
export const FRONTEND_URL = trimTrailingSlash(process.env.REACT_APP_FRONTEND_URL || DEFAULT_FRONTEND_URL);
